import React from 'react';
import { Row } from "react-flexbox-grid";
import Form from 'react-bootstrap/Form';

const PreEErrors = ({error}) =>
    <Form.Group as={Row} style={{padding: '5px'}} controlId="ipslocationsHeading">
        {error &&
        <Form.Label className='error-style' column sm={12}>
            {error ? error : ''}
        </Form.Label>
        }
    </Form.Group>

export default PreEErrors;